import styled from 'styled-components/macro'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Quote = styled.q``

export const SectionWrapper = styled.div`
  position: relative;
  padding: 1px 0;
  background-color: ${theme.colors.background};
`

export const HeroImage = styled.img`
  display: block;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: -1;

  ${mq.parallaxOn} {
    height: 100vh;
    object-fit: cover;
    object-position: 8% 8%;
  }
`
